import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './style/common.css'

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== 'production') {
  const VConsole = require('vconsole');
  new VConsole();
}

// 轨迹平台埋点
window._tcq = window._tcq || [];
var _timediff = -1;
if (typeof _tcopentime != "undefined") {
    _timediff = new Date().getTime() - _tcopentime;
}
window._tcq.push(['_vrcode', '10281-328-0']);    //平台码-产品码-0.最后一位默认为0."此条代码最重要"
window._tcq.push(['_openTime', _timediff]);
window._tcq.push(['_flag',false]); //---页面为单页时才需要增加此条代码，关闭自动数据收集，必须手动调用此方法_tcTraObj._tcTrackPage(pagename,orgpagename)
window._tcq.push(['_innerrefid', '10']);

if(typeof window._tcTraObj == "undefined" ){
  setTimeout("window._tcTraObj && window._tcTraObj._tcTrackPage('"+window.location.href+"','"+document.referrer+"');",200)
}else{
  window._tcTraObj._tcTrackPage(window.location.href,document.referrer);
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
